import React from 'react';
import { getStyle } from '../../components';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { getUrlParam, push } from '../../utils';
import './AddItem.less';
import autobind from 'autobind-decorator';

@observer
class AddItem extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'add-item',
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            data: this.props.data
        };
    }

    @autobind
    onPush(data) {
        sessionStorage.removeItem('__judgeAddress');
        push('/editadd/' + data.addressId + '?originPageId=address', this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data});
    }

    //  状态标志
    @autobind
    private _showStatus(data: any): any {
        const {prefixCls} = this.props;
        if (data.isAddress) {
            return (
                <span className={`${prefixCls}-isAddress`}>暂不配送</span>
            );
        } else if (data.isDefault === 1) {
            return (
                <span>默认</span>
            );
        } else {
            return null;
        }
    }

    render() {
        const {prefixCls, data, index, onClick, onDel, isDelete, isEdit} = this.props;
        const originPageId: string = getUrlParam('originPageId');
        let style = getStyle(this.props);
        return (
            <div style={style} className={`${prefixCls}` + (data.isAddress ? ` ${prefixCls}-no` : ``)}>
                <div className={`${prefixCls}add_active`}>
                    {
                        data.isChoose && <div className={`${prefixCls}-isChoose`}/>
                    }
                    <div className={`${prefixCls}add_detail`}>
                        <div className={`${prefixCls}detail_top`}>
                            <div onClick={() => {
                                onClick(data);
                            }}>
                            <span className={`${prefixCls}detail_top_name`}>
                                {data.contact.length > 5 ? (data.contact.substr(0, 5) + '...') : data.contact}
                            </span>
                                <span className={`${prefixCls}detail_top_phone`}>
                                {data.mobilephone.replace(/(?=(\d{4})+$)/g, ' ')}
                            </span>
                            </div>
                            <div className={`${prefixCls}add_jian`}>
                                {
                                    isDelete && <span className={`${prefixCls}add_span1`} onClick={() => {
                                        onDel(data, index);
                                    }}>删除</span>
                                }
                                {
                                    isEdit && (
                                        <span className={`${prefixCls}add_span2`} onClick={() => {
                                            this.onPush(data);
                                        }}>编辑</span>
                                    )
                                }
                            </div>
                        </div>
                        <div onClick={() => {
                            onClick(data);
                        }} className={`${prefixCls}detail_bottom`}>
                            {this._showStatus(data)}
                            <p style={(originPageId === 'shopcart' || originPageId === 'product') ? {width: '87%'} : {}}>{data.provinceName + data.cityName + data.districtName}{data.address}</p>
                            {/* <p style={(originPageId === 'shopcart' || originPageId === 'product') ? {width: '87%'} : {}}>{data.select[0].value + data.select[1].value + data.select[2].value}{data.address}</p> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/AddItem.tsx